import { api } from '../middleware/api';

// Define endpoints using injectApi pattern
export const fomidtypeApi = api
  .enhanceEndpoints({ addTagTypes: ['FOMIdtype'] })
  .injectEndpoints({
    endpoints: builder => ({
      getFOMIdtypes: builder.query<fo_midtype[], string>({
        query: cid => `fomidtype/${cid}`,
        providesTags: ['FOMIdtype']
      }),
      getFOMIdtypeById: builder.query<fo_midtype, string>({
        query: id => `fomidtype/byid/${id}`,
        providesTags: ['FOMIdtype']
      }),
      insertFOMIdtype: builder.mutation({
        query: fomidtype => ({
          url: `fomidtype/`,
          method: 'POST',
          body: fomidtype
        }),
        invalidatesTags: ['FOMIdtype']
      }),
      updateFOMIdtype: builder.mutation({
        query: fomidtype => ({
          url: `fomidtype/`,
          method: 'PUT',
          body: fomidtype
        }),
        invalidatesTags: ['FOMIdtype']
      }),
      deleteFOMIdtype: builder.mutation({
        query: fomidtype => ({
          url: `fomidtype/${fomidtype.it_id}`,
          method: 'DELETE'
        }),
        invalidatesTags: ['FOMIdtype']
      })
    }),
    overrideExisting: false
  });

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetFOMIdtypesQuery,
  useGetFOMIdtypeByIdQuery,
  useInsertFOMIdtypeMutation,
  useUpdateFOMIdtypeMutation,
  useDeleteFOMIdtypeMutation
} = fomidtypeApi;

